import { render, staticRenderFns } from "./ProducerRegistrationForm.vue?vue&type=template&id=453cadb5&scoped=true"
import script from "./ProducerRegistrationForm.vue?vue&type=script&lang=js"
export * from "./ProducerRegistrationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453cadb5",
  null
  
)

export default component.exports